export class PolizaCreditoConst {
  public static headerTable = [
    { field: 'accountingModelsNumber', title: 'Cuenta', cell: (row) => row.accountingModelsNumber ? `${row.accountingModelsNumber}` : '', class: (row) => `` },
    { field: 'banco', title: 'Banco', cell: (row) => row.banco ? `${row.banco}` : '', class: (row) => `` },
    { field: 'limite', title: 'Limite', cell: (row) => row.limite, class: (row) => `` },
    { field: 'dispuesto', title: 'Dispuesto', cell: (row) => row.dispuesto, class: (row) => `` },
    { field: 'disponible', title: 'Disponible', cell: (row) => row.disponible, class: (row) => `` },
    {
      field: 'connected', title: 'Conectada', cell: (row) => {
        if (row.connected == null) {
          return "Cargando...";
        }
        else if (row.connected === true) {
          return "Si";
        }
        else {
          return "No";
        }
      }, class: (row) => ``
    },
  ];
}
